module.exports = __webpack_public_path__ + "img/selected2-min.6760de94.png";